define('controllers/empowered',['require','layout'],function (require) {
  "use strict";
  var layout = require("layout");
  return {
    load: function () {
      return layout
        .initStatic("/fe/templates/about/empowered")
        .then(function () {
          $("[data-ScheduledSavingsDays]").text(
            window.ServerData.Settings.ScheduledSavingsDays,
          );
          $("[data-matchPlanPercentage]").text(
            window.ServerData.Settings.MatchPercentage,
          );
          layout.hideMatchPlanTemplate();
        });
    },
    unload: $.noop,
  };
});

